import { AdminUsersPage } from "../admin-users/admin-users";
import { Component } from '@angular/core';
import { CustomErrorHandler } from "@questrade/flx-commons";
import { CustomValidators } from "../../utils/validators";
import { DeveloperProvider } from "../../providers/developers";
import { FormArray, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GlobalVariables } from "../../variables/global";
import { LoadingProvider } from './../../providers/loading';
import { NavController, NavParams, IonicPage, Events } from 'ionic-angular';
import { ToastProvider } from './../../providers/toast';
import { UserModel } from './../../models/userModel';
import { environment } from './../../environments/environment';
import { FlxValidators } from './../../utils/flx-validators';
import { get, cloneDeep } from 'lodash';
import { Commons } from '../../utils/commons';

interface ValidationResult {
  [key: string]: boolean;
}
@IonicPage({
  name: 'admin-users-detail'
})
@Component({
  selector: 'page-admin-users-detail',
  templateUrl: 'admin-users-detail.html',
})
export class AdminUsersDetailPage {
  accessType: string;
  allowRequestCredentials: boolean = true;
  file: boolean | string = false;
  isAdmin: boolean;
  isReadOnly: boolean = false;
  segmentSelected: string = 'training';
  formSelected: string = 'personalInfo';
  userData: UserModel;
  offerPlans;
  offerPlansQuebec;
  offerPlansNonPrime;
  rangesForm;
  rangesFormQuebec;
  rangesFormNonPrime
  defaultPlanAndTermForm: FormGroup;
  userForm: FormGroup;
  userProdForm: FormGroup;
  widgetConfigurationForm: FormGroup;
  widgetApplySelectorForm: FormGroup;
  widgetPurchaseSelectorForm: FormGroup;
  validationInfoForm: FormGroup;
  trust_urls: string[] = [];
  public validationInfoFormProps;
  public widgetApplySelectorFormProps;
  public widgetPurchaseSelectorFormProps;
  private maxValue = '999999.99';
  private noInterestNoPaymentsSACPlanID = "6";
  public planAndTermRanges = [];
  public planAndTermRangesNonPrime = [];
  public planAndTermRangesQuebec = [];
  public offerNonPrime = false;
  public selectedPlan;
  private hoverText: string;
  private initialPage: number = 1;
  public rangesLength = 0;
  public rangesNonPrimeLength = 0;
  public widgetConfigurationFormProps;
  public planAndTermsNonPrimeValidators = {
    bottom: [
      this.requiredValidator.bind(this),
      FlxValidators.minValueValidator(0),
      // this.rangeAlreadySelectedBottomNonPrimeValidator.bind(this),
      this.bottomValidator.bind(this),
    ],
    top: [
      this.requiredValidator.bind(this),
      FlxValidators.minValueValidator(0),
      // this.rangeAlreadySelectedTopNonPrimeValidator.bind(this),
      this.topValidator.bind(this)
    ],
    plan: [this.requiredValidator.bind(this)],
    term: [this.requiredValidator.bind(this)]
  };
  public planAndTermsValidators = {
    bottom: [
      this.requiredValidator.bind(this),
      FlxValidators.minValueValidator(0),
      // this.rangeIntersectionValidator.bind(this),
      // this.rangeAlreadySelectedBottomValidator.bind(this),
      this.bottomValidator.bind(this),
    ],
    top: [
      this.requiredValidator.bind(this),
      FlxValidators.minValueValidator(0),
      // this.rangeIntersectionValidator.bind(this),
      // this.rangeAlreadySelectedBottomValidator.bind(this),
      this.topValidator.bind(this)
    ],
    plan: [this.requiredValidator.bind(this)],
    term: [this.requiredValidator.bind(this)]
  };
  public widgetPurchaseSelectorForPOSProps;
  public widgetPurchaseSelectorOnlineForPOSProps;

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private devProvider: DeveloperProvider,
    private toast: ToastProvider,
    private loading: LoadingProvider,
    private events: Events,
    private customErrorHandler: CustomErrorHandler
  ) {
    this.allowRequestCredentials = (environment.name === 'training');
    this.isAdmin = GlobalVariables.accessType !== 'DEV';

    this.widgetConfigurationFormProps = {
      widget_source: {
        type: 'select',
        options: {
          POS: 'POS',
          ONLINE: 'ONLINE'
        }
      },
    };
    this.widgetApplySelectorFormProps = {
      mfa: {
        type: 'checkbox',
        label: 'MFA'
      }
    };
    this.widgetPurchaseSelectorFormProps = {
      sms: {
        type: 'checkbox',
        label: 'SMS',
        checked: true
      },
      email: {
        type: 'checkbox',
        label: 'Email',
        checked: true
      }
    };
    this.widgetPurchaseSelectorForPOSProps = {
      instorePOS_email: {
        type: 'checkbox',
        label: 'Disable Email',
        checked: false
      }
    }
    this.validationInfoFormProps = {
      fields: {
        validation_email: {
          label: 'Email Address (required)',
          type: 'email',
          validations: {
            required: 'Oops, this is a required field.',
            format: ' Oops, wrong format'
          }
        },
        validation_phone_number: {
          label: 'Mobile number (required)',
          type: 'tel',
          validations: {
            required: 'Oops, this is a required field.',
            format: ' Oops, wrong format'
          }
        }
      }
    };
    this.widgetPurchaseSelectorOnlineForPOSProps = {
      sms: {
        type: 'checkbox',
        label: 'SMS',
        checked: true
      },
      email: {
        type: 'checkbox',
        label: 'Email',
        checked: true
      },
        securityQA: {
          type: 'checkbox',
          label: 'Security QA',
          checked: true
        }
    }
  }

  async ngOnInit() {
    await this.getUserData();
    if (this.userData) {
      this.trust_urls = !this.userData.trust_url || !this.userData.trust_url[0] ? [] : this.userData.trust_url;
      let loadingInstance = this.loading.create();
      try {
        const planInformation = await this.recoverPlanInformation();
        this.offerNonPrime = get(planInformation, ['plan_and_term_ranges_non_prime', 'offer_non_prime'], false);
      } catch (err) {
        this.offerNonPrime = false;
        this.offerPlansNonPrime = [];
      } finally {
        loadingInstance.dismiss();
      }

    }
  }

  setRangesFormMasks(rangesForm) {
    rangesForm.controls.ranges.controls.forEach(range => {
      range.controls.bottom.valueChanges.subscribe(val => {
        range.controls.bottom.setValue(this.calculateMaskedValue(val), { emitEvent: false });
      });

      range.controls.top.valueChanges.subscribe(val => {
        range.controls.top.setValue(this.calculateMaskedValue(val), { emitEvent: false });
      });
    });
  }

  calculateMaskedValue(val) {
    const RANGE_VALUE_REGEX = /^([0-9]+(\.[0-9]{0,2})?)/g;
    let value = '';

    if (val) value = val.match(RANGE_VALUE_REGEX);

    return value ? value[0] : '';
  }

  async getUserData() {
    if (this.navParams.get('userDetail')) {
      this.userData = this.navParams.get('userDetail');
      this.planAndTermRanges = get(this.userData, ['plan_and_term_ranges', 'plan_and_term_ranges'], []);
      this.planAndTermRangesQuebec = get(this.userData, ['plan_and_term_ranges_quebec', 'plan_and_term_ranges_quebec'], []);
      this.planAndTermRangesNonPrime = get(this.userData, ['plan_and_term_ranges_non_prime', 'plan_and_term_ranges'], []);
      this.offerPlans = this.navParams.get('offerPlans');
      this.offerPlansQuebec = get(this.userData, ['plan_and_term_ranges_quebec', 'offer_types'], []);
      this.offerPlansNonPrime = get(this.userData, ['plan_and_term_ranges_non_prime', 'offer_types'], []);
      this.createForm();
    } else {
      await this.callProvider();
    }
  }

  async callProvider() {
    let loadingInstance = this.loading.create();
    try {
      if (GlobalVariables.accessType === 'ADMIN') {
        this.userData = await this.devProvider.getUsers(this.initialPage).toPromise();
        this.createForm();
      } else if (GlobalVariables.accessType === 'DEV') {
        this.userData = await this.devProvider.getUser(GlobalVariables.username).toPromise();
        this.createForm();
      } else {
        loadingInstance.dismiss();
        this.navCtrl.push('home');
      }
    } catch (error) {
      this.customErrorHandler.handleError(error.json());
    } finally {
      loadingInstance.dismiss()
    }
  }
  createForm() {
    this.buildRangesForm();
    this.buildRangesQuebecForm();
    this.buildRangesNonPrimeForm();
    this.buildValidationInfoForm();
    this.buildWidgetConfigurationForm();

    this.userForm = this.formBuilder.group({
      allow_guest: new FormControl(this.userData.allow_guest),
      allow_merchant_override: new FormControl(this.userData.allow_merchant_override),
      auth_token: new FormControl(this.userData.auth_token, [Validators.required, CustomValidators.trimValidator]),
      client_id: new FormControl(this.userData.client_id, [Validators.required, CustomValidators.trimValidator]),
      client_secret: new FormControl(this.userData.client_secret, [Validators.required, CustomValidators.trimValidator]),
      default_requested_amount: new FormControl(this.userData.default_requested_amount, [CustomValidators.numberValidator]),
      email: new FormControl(this.userData.email, [Validators.required, CustomValidators.emailValidator, CustomValidators.trimValidator]),
      first_name: new FormControl(this.userData.first_name, [Validators.required, CustomValidators.trimValidator]),
      last_name: new FormControl(this.userData.last_name, [Validators.required, CustomValidators.trimValidator]),
      merchant: new FormControl(this.userData.merchant, [Validators.required, CustomValidators.trimValidator]),
      merchant_password: new FormControl(this.userData.merchant_password, [CustomValidators.trimValidator]),
      merchant_username: new FormControl(this.userData.merchant_username, [CustomValidators.trimValidator]),
      notification_uri: new FormControl(this.userData.notification_uri, [CustomValidators.urlValidator]),
      redirection_error_uri: new FormControl(this.userData.redirection_error_uri, [CustomValidators.urlValidator]),
      redirection_success_uri: new FormControl(this.userData.redirection_success_uri, [CustomValidators.urlValidator]),
      status: new FormControl(this.userData.status),
      trust_url: new FormControl('', [CustomValidators.urlValidator]),
      username: new FormControl(this.userData.username, [Validators.required, CustomValidators.trimValidator]),
      role: new FormControl(this.userData.role || 'ONLINE', [Validators.required, CustomValidators.trimValidator]),
      enable_quebec_exception_plans: new FormControl(this.userData.enable_quebec_exception_plans)
    });

    this.userProdForm = this.formBuilder.group({
      client_id_prod: new FormControl(this.userData.client_id_prod, [Validators.required, CustomValidators.trimValidator]),
      client_secret_prod: new FormControl(this.userData.client_secret_prod, [Validators.required, CustomValidators.trimValidator]),
      auth_token_prod: new FormControl(this.userData.auth_token_prod, [CustomValidators.trimValidator]),
    })

    if (!this.isAdmin) {
      this.isReadOnly = true;
      this.userForm.removeControl('merchant_username');
      this.userForm.removeControl('merchant_password');
      this.userForm.removeControl('status');
      this.userForm.removeControl('default_requested_amount');
      this.userForm.removeControl('allow_guest');
      this.userForm.removeControl('enable_quebec_exception_plans');
    } else {
      this.userForm.removeControl('auth_token');
    }
  }

  buildValidationInfoForm() {
    this.validationInfoForm = this.formBuilder.group({
      validation_phone_number: new FormControl(get(this.userData, ['default_validation_info', 'phone_number'], null), [Validators.required, FlxValidators.phoneValidator, CustomValidators.trimValidator]),
      validation_email: new FormControl(get(this.userData, ['default_validation_info', 'email'], null), [Validators.required, CustomValidators.emailValidator, CustomValidators.trimValidator])
    })
  }

  checkRequiredPlansAndTerms() {
    this.rangesForm.controls.ranges.controls.forEach(range => {
      this.markAsErrorAndTouched(range.controls.plan);
      this.markAsErrorAndTouched(range.controls.term);
      this.markAsErrorAndTouched(range.controls.top);
      this.markAsErrorAndTouched(range.controls.bottom);
    });

    this.rangesForm.updateValueAndValidity();

    this.rangesFormQuebec.controls.ranges_quebec.controls.forEach(range => {
      this.markAsErrorAndTouched(range.controls.plan);
      this.markAsErrorAndTouched(range.controls.term);
      this.markAsErrorAndTouched(range.controls.top);
      this.markAsErrorAndTouched(range.controls.bottom);
    });

    this.rangesFormQuebec.updateValueAndValidity();

    this.rangesFormNonPrime.controls.ranges.controls.forEach(range => {
      this.markAsErrorAndTouched(range.controls.plan);
      this.markAsErrorAndTouched(range.controls.term);
      this.markAsErrorAndTouched(range.controls.top);
      this.markAsErrorAndTouched(range.controls.bottom);
    });

    this.rangesFormNonPrime.updateValueAndValidity();
  }

  markAsErrorAndTouched(control) {
    if (!control.value) {
      control.setErrors({ required: true });
      control.markAsTouched();
    };
  }

  calculateOpenRangesCount(rangesForm) {
    let totalOpenRanges = 0;

    rangesForm.controls.ranges.controls.forEach(range => {
      if (!range.controls.top.value) {
        totalOpenRanges += 1;
      };
    });

    return totalOpenRanges;
  }

  checkForOpenRanges(rangesForm) {
    let openRangesCount = this.calculateOpenRangesCount(rangesForm);

    this.rangesForm.controls.ranges.controls.forEach(range => {
      if (openRangesCount !== 1 && !range.controls.top.value) {
        range.controls.top.setErrors({ moreThanOneOpenRange: true });
      }

      if (openRangesCount === 1 && range.controls.top.errors && range.controls.top.errors['moreThanOneOpenRange']) {
        delete range.controls.top.errors['moreThanOneOpenRange'];
        range.controls.top.updateValueAndValidity();
      }
    });

    this.rangesForm.updateValueAndValidity();
  }

  shouldHaveWidgetConfiguration() {
    return (this.userData.role === 'POS' && this.isAdmin);
  }

  markInputAsInvalid(input) {
    Commons.markAsInvalid(input);
    this.validationInfoForm.controls[input].markAsTouched();
    this.validationInfoForm.controls[input].markAsDirty();
    this.validationInfoFormProps.fields[input]['blur'] = true;
  }

  validateForms() {
    let formValidity = true;
    if (this.isAdmin
      && this.userForm.controls['merchant_username']['_value'] != this.userData.merchant_username
      && (this.userForm.controls['merchant_password']['_value'] == null || this.userForm.controls['merchant_password']['_value'] == "")) {
      this.markAsErrorAndTouched(this.userForm.controls['merchant_password']);
      formValidity = false;
    }

    if (!this.userForm.valid || !this.rangesForm.valid ||
      (this.shouldHavePlanAndTermsQuebec() && !this.rangesFormQuebec.valid) ||
      (this.shouldHaveValidationForm() && !this.validationInfoForm.valid) ||
      (this.shouldHavePlanAndTermsNonPrime() && !this.rangesFormNonPrime.valid)) {
      if (!this.userForm.valid) {
        this.formSelected = 'personalInfo';
      } else if (!this.rangesForm.valid) {
        this.formSelected = 'planAndTerms';
      } else if (this.shouldHavePlanAndTermsNonPrime() && !this.rangesFormNonPrime.valid) {
        this.formSelected = 'planAndTermsNonPrime';
      } else if (this.shouldHavePlanAndTermsQuebec() && !this.rangesFormQuebec.valid) {
        this.formSelected = 'planAndTermsQuebec';
      } else if (!this.validationInfoForm.valid) {
        this.formSelected = 'validationInfo';
        if (!this.validationInfoForm.controls['validation_email'].valid) {
          this.markInputAsInvalid('validation_email')
        }

        if (!this.validationInfoForm.controls['validation_phone_number'].valid) {
          this.markInputAsInvalid('validation_phone_number')
        }
      }

      formValidity = false;
    };

    // check widgetPurchaseSelectorOnlineForPOSProps selected any one value
    if (this.widgetConfigurationForm.controls['widget_source']['_value'] === 'ONLINE' && !this.widgetPurchaseSelectorForm.controls['sms']['_value'] && !this.widgetPurchaseSelectorForm.controls['email']['_value'] && !this.widgetPurchaseSelectorForm.controls['securityQA']['_value']) {
      formValidity = false;
    }

    return formValidity;
  }

  shouldHaveValidationForm() {
    return (environment.name !== 'production' && this.userData.role === 'POS');
  }

  addValidationInformation() {
    let validationInformation = undefined;

    if (this.shouldHaveValidationForm() && this.validationInfoForm.valid) {
      validationInformation = {
        email: this.validationInfoForm.controls['validation_email']['_value'],
        phone_number: this.validationInfoForm.controls['validation_phone_number']['_value']
      };
    }

    return validationInformation;
  }

  save() {
    const areFormsValid = this.validateForms();

    this.checkRequiredPlansAndTerms();
    if (!areFormsValid) return;

    this.checkForOpenRanges(this.rangesForm);
    this.checkForOpenRanges(this.rangesFormNonPrime);
    this.cleanOpenRanges(this.planAndTermRanges);
    this.cleanOpenRanges(this.planAndTermRangesNonPrime);

    let loadingInstance = this.loading.create();

    if (this.isAdmin) {
      let userData = { ...this.userForm.value };
      userData.plan_and_term_ranges = this.planAndTermRanges;
      userData.plan_and_term_ranges_quebec = userData.enable_quebec_exception_plans ? this.planAndTermRangesQuebec : [];
      userData.plan_and_term_ranges_non_prime = this.offerNonPrime ? this.planAndTermRangesNonPrime : [];
      userData['default_validation_info'] = this.addValidationInformation();
      userData['widget_configuration'] = this.addWidgetConfigurationData();
      userData.client_id_prod = this.userProdForm.value.client_id_prod;
      userData.client_secret_prod = this.userProdForm.value.client_secret_prod;
      userData.auth_token_prod = this.userProdForm.value.auth_token_prod;
      userData.trust_url = this.trust_urls;
      
      this.devProvider.updateUser(userData)
        .subscribe(data => {
          loadingInstance.dismiss();
          this.toast.create('Updated successfully', 'notification');
          this.returnToUserList();
        }, error => {
          loadingInstance.dismiss();
          this.customErrorHandler.handleError(error.json());
        })
    }
    else {
      let updateUserInfo = {
        notification_uri: this.userForm.controls['notification_uri']['_value'],
        redirection_success_uri: this.userForm.controls['redirection_success_uri']['_value'],
        redirection_error_uri: this.userForm.controls['redirection_error_uri']['_value'],
        plan_and_term_ranges: this.planAndTermRanges,
        plan_and_term_ranges_quebec: this.planAndTermRangesQuebec,
        plan_and_term_ranges_non_prime: this.offerNonPrime ? this.planAndTermRangesNonPrime : [],
        default_validation_info: this.addValidationInformation(),
        trust_url: this.trust_urls
      }

      this.devProvider.updateNoAdminUser(updateUserInfo, this.userForm.controls['username']['_value'])
        .subscribe(data => {
          loadingInstance.dismiss();
          this.toast.create('Updated successfully', 'notification');
        }, error => {
          loadingInstance.dismiss();
          this.customErrorHandler.handleError(error.json());
        })
    }
  }

  addWidgetConfigurationData() {
    let widgetConfiguration:any = {
      widget_source: this.widgetConfigurationForm.controls['widget_source']['_value'],
      apply: {
        mfa_validation_selector: {
          mfa: {
            is_active: this.widgetApplySelectorForm.controls['mfa']['_value']
          }
        }
      },
      purchase: {
        mfa_validation_selector: {
          sms: {
            is_active: this.widgetPurchaseSelectorForm.controls['sms']['_value']
          },
          email: {
            is_active: this.widgetPurchaseSelectorForm.controls['email']['_value']
          }
        }
      }, 

    };
    if (
      this.widgetConfigurationForm.controls["widget_source"]["_value"] === "POS"
    ) {
      widgetConfiguration.purchase.mfa_validation_selector.instorePOS_email = {
        is_active:
          !this.widgetPurchaseSelectorForm.controls["instorePOS_email"][
            "_value"
          ],
      };
    }
    if (this.widgetConfigurationForm.controls["widget_source"]["_value"] === "ONLINE") {
      widgetConfiguration.purchase.mfa_validation_selector.securityQA = {
        is_active: this.widgetPurchaseSelectorForm.controls['securityQA']['_value']
      };
    } 

    return widgetConfiguration;
  }

  cleanOpenRanges(planAndTermRanges) {
    planAndTermRanges.forEach(range => {
      if (!range.top) {
        range.top = this.maxValue;
      };
    });
  }

  saveProdForm() {
    if (!this.userProdForm.valid || !this.isAdmin) return;
    let userModel: UserModel;
    let planAndTermRanges = get(this.userData, ['plan_and_term_ranges', 'plan_and_term_ranges'], []);
    let planAndTermRangesNonPrime = get(this.userData, ['plan_and_term_ranges_non_prime', 'plan_and_term_ranges'], []);
    userModel = this.userData;
    userModel.client_id_prod = this.userProdForm.value.client_id_prod;
    userModel.client_secret_prod = this.userProdForm.value.client_secret_prod;
    userModel.auth_token_prod = this.userProdForm.value.auth_token_prod;
    userModel.plan_and_term_ranges = planAndTermRanges;
    userModel.plan_and_term_ranges_quebec = this.userData.enable_quebec_exception_plans ? this.planAndTermRangesQuebec : [];
    userModel.plan_and_term_ranges_non_prime = this.offerNonPrime ? planAndTermRangesNonPrime : [];
    userModel.trust_url = this.trust_urls;

    let loadingInstance = this.loading.create();
    this.devProvider.updateUser(userModel)
      .subscribe(data => {
        loadingInstance.dismiss();
        this.toast.create('Updated successfully', 'notification');
        this.returnToUserList();
      }, error => {
        loadingInstance.dismiss();
        this.customErrorHandler.handleError(error.json());
      })
  }

  returnToUserList() {
    this.devProvider.getUsers(this.initialPage)
      .subscribe(data => {
        this.navCtrl.setRoot(AdminUsersPage, { users: data.developers, admin: GlobalVariables.username });
      }, error => {
        this.customErrorHandler.handleError(error.json());
      });
  }

  over(inputHovered: string) {
    this.hoverText = inputHovered;
  }

  fileChange(event) {
    let filesSelected = document.getElementById("inputFileToLoad")['files'];
    if (filesSelected.length > 0) {
      let fileToLoad = filesSelected[0];
      let fileReader = new FileReader();
      /*
        Check extension
      */
      let validExtension = false;
      ['image/png', 'image/jpeg'].forEach((extension) => {
        if (fileToLoad.type === extension) validExtension = true;
      })

      if (!validExtension) return this.toast.create('Extension file is not supported', 'error');

      fileReader.onload = (fileLoadedEvent) => {
        let srcData = fileLoadedEvent.target['result'] as string; // <--- data: base64;
        let newImage = document.createElement('img');
        newImage.src = srcData;
        newImage.onload = async () => {
          /*
            Check Dimensions
          */
          let validDimensions = { height: 150, width: 160 };
          if (Number(newImage.width) > validDimensions.width || Number(newImage.height) > validDimensions.height) {
            return this.toast.create('Image size must be minor than 150x160 pixels', 'error');
          }

          this.file = fileLoadedEvent.target['result'] as string;

          if (this.userData['merchant_logo']) {
            await this.updateLogo();
          } else {
            await this.uploadLogo();
          }

          this.userData['merchant_logo'] = this.file;
        }
      }
      fileReader.readAsDataURL(fileToLoad);
    }
  }

  openExamine() {
    document.querySelector('#inputFileToLoad')['click']();
  }

  async uploadLogo() {
    if (!this.file) return false;
    try {
      await this.devProvider.uploadLogo({
        file: this.file,
        user: this.userForm.controls['username']['_value'],
        isAdmin: this.isAdmin
      }).toPromise();

      this.userData['merchant_logo'] = this.file;
      this.toast.create('Uploaded successfully', 'notification');
      await this.getUserData();
      let loadingInstance = this.loading.create();
      try {
        await this.recoverPlanInformation();
        this.createForm();
      } catch (error) {
        this.customErrorHandler.handleError(error.json());
      } finally {
        loadingInstance.dismiss();
      }
    } catch (error) {
      this.customErrorHandler.handleError(error.json());
    }

  }

  requestProdCredentials() {
    if (this.allowRequestCredentials) {
      this.devProvider.requestProdCredentials(this.userForm.controls['username']['_value'])
        .subscribe(data => {
          this.toast.create('We sent an email for the Administrator in order to enable your Production Account, a confirmation email will send once an Admin review and accept your request.', 'notification');
        }, error => {
          this.customErrorHandler.handleError(error.json());
        })
    }
  }

  sendProdCredentials() {
    this.devProvider.sendProdCredentials(this.userForm.controls['username']['_value'])
      .subscribe(data => {
        this.toast.create('Credentials sent', 'notification');
      }, error => {
        this.customErrorHandler.handleError(error.json());
      })
  }

  async updateLogo() {
    if (!this.file) return false;

    document.querySelector('#inputFileToLoad')['click']();
    try {
      await this.devProvider.updateLogo({
        file: this.file,
        user: this.userForm.controls['username']['_value'],
        isAdmin: this.isAdmin
      }).toPromise();
      this.userData['merchant_logo'] = this.file;
      this.toast.create('Updated successfully', 'notification');

      if (this.isAdmin) {
        this.returnToUserList();
      } else {
        await this.getUserData();
        if (this.navParams.get("userDetail")) {
          let loadingInstance = this.loading.create();
          try {
            await this.recoverPlanInformation();
            this.createForm();
          } catch (error) {
            this.customErrorHandler.handleError(error.json());
          } finally {
            loadingInstance.dismiss();
          }
        }
      }
    } catch (error) {
      this.customErrorHandler.handleError(error.json());
    }
  }

  segmentChanged(segment) {
    this.segmentSelected = segment.value;
  }

  async recoverPlanInformation() {
    try {
      const data = await this.devProvider.getUserPlans(this.userData.username).toPromise();
      let planAndTerms = data.plan_and_term_ranges;
      this.offerPlans = get(planAndTerms, ['offer_types'], []);
      this.offerPlansQuebec = get(data, ['plan_and_term_ranges_quebec', 'offer_types'], []);
      this.offerPlansNonPrime = get(data, ['plan_and_term_ranges_non_prime', 'offer_types'], []);
      this.planAndTermRanges = get(planAndTerms, ['plan_and_term_ranges'], []);
      this.planAndTermRangesQuebec = get(data, ['plan_and_term_ranges_quebec', 'plan_and_term_ranges_quebec'], []);
      this.planAndTermRangesNonPrime = get(data, ['plan_and_term_ranges_non_prime', 'plan_and_term_ranges'], []);
      return data;
    } catch (err) {
      throw err;
    }
  }

  async formChanged(option) {
    if (option == 'planAndTermsQuebec' || option == 'planAndTerms' || option == 'planAndTermsNonPrime') {
      let loadingInstance = this.loading.create();
      try {
        await this.recoverPlanInformation();
        this.createForm();
        this.formSelected = option;
      } catch (error) {
        this.customErrorHandler.handleError(error.json());
      } finally {
        loadingInstance.dismiss();
      }
    } else {
      this.formSelected = option;
    }

  }

  getButtonClass(value) {
    return {
      'user-form__form-btn': true,
      'user-form__form-btn--selected': (this.formSelected === value),
    }
  }

  getObjectValues(object) {
    return Object.keys(object).map(key => object[key]);
  }

  buildWidgetConfigurationForm() {
    this.widgetConfigurationForm = this.formBuilder.group({
      widget_source: new FormControl(get(this.userData, ['widget_configuration', 'widget_source'], 'POS'), [Validators.required, CustomValidators.trimValidator]),
    });
    this.widgetApplySelectorForm = this.formBuilder.group({
      mfa: new FormControl(get(this.userData, ['widget_configuration', 'apply', 'mfa_validation_selector', 'mfa', 'is_active'], true), [Validators.required]),
    });
    this.widgetPurchaseSelectorForm = this.formBuilder.group({
      sms: new FormControl(get(this.userData, ['widget_configuration', 'purchase', 'mfa_validation_selector', 'sms', 'is_active'], true), [Validators.required]),
      email: new FormControl(get(this.userData, ['widget_configuration', 'purchase', 'mfa_validation_selector', 'email', 'is_active'], true), [Validators.required]),
      instorePOS_email: new FormControl(!get(this.userData, ['widget_configuration', 'purchase', 'mfa_validation_selector', 'instorePOS_email', 'is_active'], false), [Validators.required]),
      securityQA: new FormControl(get(this.userData, ['widget_configuration', 'purchase', 'mfa_validation_selector', 'securityQA', 'is_active'], true), [Validators.required]),
    });

  }

  buildRangesForm() {
    this.rangesForm = new FormGroup({ ranges: new FormArray([]) });
    if (this.planAndTermRanges.length) {
      this.planAndTermRanges.forEach((range, index) => {
        const newRangeValues = {
          bottom: range.bottom,
          top: range.top >= this.maxValue ? '' : range.top,
          plan: range.plan,
          term: range.term
        };
        this.addRangeToRangesForm(newRangeValues);
      });
    }
    this.setRangesFormMasks(this.rangesForm);
  }

  buildRangesQuebecForm() {
    this.rangesFormQuebec = new FormGroup({ ranges_quebec: new FormArray([]) });
    if (this.planAndTermRangesQuebec.length) {
      this.planAndTermRangesQuebec.forEach((range) => {
        const newRangeValues = {
          bottom: range.bottom,
          top: range.top >= this.maxValue ? '' : range.top,
          plan: range.plan,
          term: range.term
        };
        this.addRangeToRangesFormQuebec(newRangeValues);
      });
    } else {
      this.planAndTermRangesQuebec = cloneDeep(this.planAndTermRanges);
      this.planAndTermRangesQuebec.forEach((range) => {
        const newRangeValues = {
          bottom: range.bottom,
          top: range.top >= this.maxValue ? '' : range.top,
          plan: this.checkIfPlanIsNoPaymentsNoInterestSAC(range.plan.offer_type_id) ? null : range.plan,
          term: this.checkIfPlanIsNoPaymentsNoInterestSAC(range.plan.offer_type_id) ? null : range.term,
        };
        this.addRangeToRangesFormQuebec(newRangeValues);
      });
    }
  }

  buildRangesNonPrimeForm() {
    this.rangesFormNonPrime = new FormGroup({ ranges: new FormArray([]) });
    if (this.planAndTermRangesNonPrime.length) {
      this.planAndTermRangesNonPrime.forEach((range) => {
        const newRangeValues = {
          bottom: range.bottom,
          top: range.top >= this.maxValue ? '' : range.top,
          plan: range.plan,
          term: range.term
        };
        this.addRangeToRangesFormNonPrime(newRangeValues);
      });
    }
    this.setRangesFormMasks(this.rangesFormNonPrime);
  }

  checkIfPlanIsNoPaymentsNoInterestSAC(offer_type_id: String) {
    return offer_type_id === this.noInterestNoPaymentsSACPlanID;
  }

  get ranges() {
    return this.rangesForm.get('ranges') as FormArray;
  }

  get ranges_quebec() {
    return this.rangesFormQuebec.get('ranges_quebec') as FormArray;
  }

  get ranges_non_prime() {
    return this.rangesFormNonPrime.get('ranges') as FormArray;
  }

  addRange() {
    if (!this.canAddRange(this.planAndTermRanges)) return;

    const difference = 0.01;
    const rangeLength = this.rangesForm.controls.ranges.controls.length - 1;
    const lastThresholdTop = (rangeLength < 0) ? '-0.01' : this.rangesForm.controls.ranges.controls[rangeLength].controls.top.value;
    const newThresholdBottom = (lastThresholdTop) ? (parseFloat(lastThresholdTop) + difference).toString() : "";
    const newRangeValues = { bottom: newThresholdBottom, top: '', plan: '', term: '' };
    const newPlanAndTermValues = {
      bottom: newThresholdBottom !== "" ? newThresholdBottom : "",
      top: '',
      plan: null,
      term: null
    };

    this.addRangeToRangesForm(newRangeValues);
    this.addPlanAndTermToRanges(newPlanAndTermValues);

    this.addRangeToRangesFormQuebec(newRangeValues);
    this.addPlanAndTermToRangesQuebec(newPlanAndTermValues);
  }

  updateTreeValidity(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.controls[key];

      abstractControl.markAsTouched();
      abstractControl.markAsDirty();

      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.updateTreeValidity(abstractControl);
      } else {
        abstractControl.updateValueAndValidity();
      }
    });
  }

  addRangeNonPrime() {
    if (!this.canAddRange(this.planAndTermRangesNonPrime)) return;

    const difference = 0.01;
    const rangeLength = this.rangesFormNonPrime.controls.ranges.controls.length - 1;
    const lastThresholdTop = (rangeLength < 0) ? '-0.01' : this.rangesFormNonPrime.controls.ranges.controls[rangeLength].controls.top.value;
    const newThresholdBottom = (lastThresholdTop) ? (parseFloat(lastThresholdTop) + difference).toString() : "";
    const newRangeValues = { bottom: newThresholdBottom, top: '', plan: '', term: '' };
    const newPlanAndTermValues = {
      bottom: newThresholdBottom !== "" ? newThresholdBottom : "",
      top: '',
      plan: null,
      term: null
    };

    this.addRangeToRangesFormNonPrime(newRangeValues);
    this.addPlanAndTermToRangesNonPrime(newPlanAndTermValues);
  }

  canAddRange(planAndTermRanges) {

    this.checkRequiredPlansAndTerms();

    const lastThreshold = planAndTermRanges[planAndTermRanges.length - 1];

    if (!lastThreshold) return true;

    if (lastThreshold.plan && lastThreshold.term) {
      return true;
    } else {
      return false;
    }
  }

  removeRange(index) {
    this.rangesForm.get('ranges').removeAt(index);
    this.planAndTermRanges.splice(index, 1);

    this.rangesFormQuebec.get('ranges_quebec').removeAt(index);
    this.planAndTermRangesQuebec.splice(index, 1);

    this.checkForOpenRanges(this.rangesForm);

    this.updateTreeValidity(this.rangesForm);
    this.updateTreeValidity(this.rangesFormQuebec);
  }

  removeRangeNonPrime(index) {
    this.rangesFormNonPrime.get('ranges').removeAt(index);
    this.planAndTermRangesNonPrime.splice(index, 1);

    this.checkForOpenRanges(this.rangesFormNonPrime);
    this.updateTreeValidity(this.rangesFormNonPrime);
    this.rangesFormNonPrime.markAsTouched();
  }

  addRangeToRangesForm(values) {
    this.rangesForm.get('ranges').push(
      new FormGroup({
        id: new FormControl(this.rangesLength++),
        bottom: new FormControl(values.bottom, this.planAndTermsValidators.bottom),
        top: new FormControl(values.top, this.planAndTermsValidators.top),
        plan: new FormControl(values.plan ? values.plan.offer_type_id : "", this.planAndTermsValidators.plan),
        term: new FormControl(values.term, this.planAndTermsValidators.term)
      })
    );

    const currentRange = this.rangesForm.controls.ranges.controls.length - 1;
    const currentRangeControls = this.rangesForm.controls.ranges.controls[currentRange].controls;
    this.addMaskToNewRange(currentRangeControls.bottom);
    this.addMaskToNewRange(currentRangeControls.top);
  }

  addRangeToRangesFormQuebec(values) {
    this.rangesFormQuebec.get('ranges_quebec').push(
      new FormGroup({
        id: new FormControl(this.rangesLength++),
        bottom: new FormControl(values.bottom),
        top: new FormControl(values.top),
        plan: new FormControl(values.plan ? values.plan.offer_type_id : "", this.planAndTermsValidators.plan),
        term: new FormControl(values.term, this.planAndTermsValidators.term)
      })
    );

    const currentRange = this.rangesFormQuebec.controls.ranges_quebec.controls.length - 1;
    const currentRangeControls = this.rangesFormQuebec.controls.ranges_quebec.controls[currentRange].controls;
    currentRangeControls.plan.markAsTouched();
    currentRangeControls.term.markAsTouched();
    this.addMaskToNewRange(currentRangeControls.bottom);
    this.addMaskToNewRange(currentRangeControls.top);
  }

  addRangeToRangesFormNonPrime(values) {
    this.rangesFormNonPrime.get('ranges').push(
      new FormGroup({
        id: new FormControl(this.rangesNonPrimeLength++),
        bottom: new FormControl(values.bottom, this.planAndTermsNonPrimeValidators.bottom),
        top: new FormControl(values.top, this.planAndTermsNonPrimeValidators.top),
        plan: new FormControl(values.plan ? values.plan.offer_type_id : "", this.planAndTermsNonPrimeValidators.plan),
        term: new FormControl(values.term, this.planAndTermsNonPrimeValidators.term)
      })
    );

    const currentRange = this.rangesFormNonPrime.controls.ranges.controls.length - 1;
    const currentRangeControls = this.rangesFormNonPrime.controls.ranges.controls[currentRange].controls;
    this.addMaskToNewRange(currentRangeControls.bottom);
    this.addMaskToNewRange(currentRangeControls.top);
  }

  addMaskToNewRange(range) {
    range.valueChanges.subscribe(val => {
      range.setValue(this.calculateMaskedValue(val), { emitEvent: false });
    });
  }

  addPlanAndTermToRanges(values) {
    this.planAndTermRanges.push({
      bottom: values.bottom,
      top: values.top,
      plan: values.plan,
      term: values.term
    })
  }
  addPlanAndTermToRangesNonPrime(values) {
    this.planAndTermRangesNonPrime.push({
      bottom: values.bottom,
      top: values.top,
      plan: values.plan,
      term: values.term
    })
  }
  addPlanAndTermToRangesQuebec(values) {
    this.planAndTermRangesQuebec.push({
      bottom: values.bottom,
      top: values.top,
      plan: values.plan,
      term: values.term
    })
  }

  rangeIntersectionValidator(control: FormControl): ValidationResult {
    const value = parseFloat(control.value);
    let rangeIntersection = false;

    this.rangesForm.controls.ranges.controls.forEach(range => {
      const isBiggerThanBottom = value >= parseFloat(range.controls.bottom.value);
      const isSmallerThanTop = parseFloat(range.controls.top.value) >= value;

      if (control.parent && (range.controls.id.value !== control.parent.controls['id'].value)) {
        const isCurrentBottomSmallerThanBottom = parseFloat(control.parent.controls['bottom'].value) <= parseFloat(range.controls.bottom.value);
        const isCurrentTopBiggerThanBottom = parseFloat(control.parent.controls['top'].value) >= parseFloat(range.controls.bottom.value);
        const isCurrentTopBiggerThanTop = parseFloat(control.parent.controls['top'].value) >= parseFloat(range.controls.top.value);
        const isCurrentBottomSmallerThanTop = parseFloat(control.parent.controls['bottom'].value) <= parseFloat(range.controls.top.value);

        if (isCurrentBottomSmallerThanBottom && isCurrentTopBiggerThanBottom) {
          rangeIntersection = true;
        }

        if (isCurrentTopBiggerThanTop && isCurrentBottomSmallerThanTop) {
          rangeIntersection = true;
        }

        if (isBiggerThanBottom && isSmallerThanTop) {
          rangeIntersection = true;
        };
      }
    });

    return rangeIntersection ? { rangeIntersection: true } : null;
  }

  bottomValidator(control: FormControl): ValidationResult {
    const bottomValue = parseFloat(control.value);
    const topValue = control.parent && control.parent.controls['top'].value !== '' ?
      parseFloat(control.parent.controls['top'].value) : null;

    if (topValue && bottomValue > topValue) return { invalid: true };

    return null;
  }

  topValidator(control: FormControl): ValidationResult {
    const topValue = parseFloat(control.value);
    const bottomValue = control.parent && control.parent.controls['bottom'].value !== '' ? parseFloat(control.parent.controls['bottom'].value) : null;
    if (topValue && topValue < bottomValue ||
      topValue == 0)
      return { invalid: true };

    return null;
  }

  requiredValidator(control: FormControl): ValidationResult {
    if (!control.value) return { required: true }

    return null;
  }

  rangeAlreadySelectedBottomValidator(control: FormControl): ValidationResult {
    return this.rangeAlreadySelectedValidator(control, 'top');
  }

  rangeAlreadySelectedBottomNonPrimeValidator(control: FormControl): ValidationResult {
    return this.rangeAlreadySelectedNonPrimeValidator(control, 'top');
  }

  rangeAlreadySelectedTopValidator(control: FormControl): ValidationResult {
    return this.rangeAlreadySelectedValidator(control, 'bottom');
  }

  rangeAlreadySelectedTopNonPrimeValidator(control: FormControl): ValidationResult {
    return this.rangeAlreadySelectedNonPrimeValidator(control, 'bottom');
  }

  rangeAlreadySelectedNonPrimeValidator(control: FormControl, limit): ValidationResult {
    let rangeAlreadySelected = false;
    const topValue = parseFloat(control.value);
    const bottomValue = control.parent ? parseFloat(control.parent.controls[limit].value) : null;

    this.rangesFormNonPrime.controls.ranges.controls.forEach(range => {
      if (control.parent &&
        (range.controls.id.value !== control.parent.controls['id'].value) &&
        bottomValue === parseFloat(range.controls.bottom.value) &&
        topValue === parseFloat(range.controls.top.value)) {
        rangeAlreadySelected = true;
      };
    });

    return rangeAlreadySelected ? { rangeAlreadySelected: true } : null;
  }

  rangeAlreadySelectedValidator(control: FormControl, limit): ValidationResult {
    let rangeAlreadySelected = false;
    const topValue = parseFloat(control.value);
    const bottomValue = control.parent ? parseFloat(control.parent.controls[limit].value) : null;

    this.rangesForm.controls.ranges.controls.forEach(range => {
      if (control.parent &&
        (range.controls.id.value !== control.parent.controls['id'].value) &&
        bottomValue === parseFloat(range.controls.bottom.value) &&
        topValue === parseFloat(range.controls.top.value)) {
        rangeAlreadySelected = true;
      };
    });

    return rangeAlreadySelected ? { rangeAlreadySelected: true } : null;
  }

  handleBottomRangeForNonPrimeChange(event, index) {
    this.planAndTermRangesNonPrime[index].bottom = event.value;
    this.rangesFormNonPrime.controls.ranges.controls[index].controls.top.updateValueAndValidity();

    Commons.markAsValid(`top_${index}`);
  }

  handleTopRangeForNonPrimeChange(event, index) {

    this.checkForOpenRanges(this.rangesFormNonPrime);
    this.planAndTermRangesNonPrime[index].top = event.value;
    this.rangesFormNonPrime.controls.ranges.controls[index].controls.bottom.updateValueAndValidity();


    Commons.markAsValid(`bottom_${index}`);
  }

  handleBottomRangeChange(event, index) {
    this.planAndTermRanges[index].bottom = event.value;
    this.rangesForm.controls.ranges.controls[index].controls.top.updateValueAndValidity();

    this.planAndTermRangesQuebec[index].bottom = event.value;
    this.rangesFormQuebec.controls.ranges_quebec.controls[index].controls.bottom.setValue(event.value);

    Commons.markAsValid(`top_${index}`);
  }

  handleTopRangeChange(event, index) {

    this.checkForOpenRanges(this.rangesForm);
    this.planAndTermRanges[index].top = event.value;
    this.rangesForm.controls.ranges.controls[index].controls.bottom.updateValueAndValidity();

    this.planAndTermRangesQuebec[index].top = event.value;
    this.rangesFormQuebec.controls.ranges_quebec.controls[index].controls.top.setValue(event.value);

    Commons.markAsValid(`bottom_${index}`);
  }

  handlePlanChange(planId, index) {
    this.planAndTermRanges[index].plan = this.offerPlans.find(plan => plan.offer_type_id === planId);
    this.planAndTermRanges[index].term = null;
    let term = this.rangesForm.controls.ranges.controls[index].controls.term;

    term.setValue(null, { emitEvent: false });
  }

  handlePlanChangeQuebec(planId, index) {
    this.planAndTermRangesQuebec[index].plan = this.offerPlansQuebec.find(plan => plan.offer_type_id === planId);
    this.planAndTermRangesQuebec[index].term = null;
    let term = this.rangesFormQuebec.controls.ranges_quebec.controls[index].controls.term;

    term.setValue(null, { emitEvent: false });
  }

  handlePlanChangeNonPrime(planId, index) {
    this.planAndTermRangesNonPrime[index].plan = this.offerPlansNonPrime.find(plan => plan.offer_type_id === planId);
    this.planAndTermRangesNonPrime[index].term = null;
    let term = this.rangesFormNonPrime.controls.ranges.controls[index].controls.term;

    term.setValue(null, { emitEvent: false });
  }

  handleTermChange(term, index) {
    this.planAndTermRanges[index].term = term;
  }

  handleTermChangeQuebec(term, index) {
    this.planAndTermRangesQuebec[index].term = term;
  }

  handleTermChangeNonPrime(term, index) {
    this.planAndTermRangesNonPrime[index].term = term;
  }

  handleAddTrustUrl() {
    const newTrustUrl = this.userForm.controls['trust_url'].value;
    if (newTrustUrl && this.userForm.controls['trust_url'].valid && this.trust_urls.indexOf(newTrustUrl) == -1) {
      this.trust_urls.push(newTrustUrl);
      this.userForm.controls['trust_url'].setValue("");
    }
  }

  handleRemoveTrustUrl(index) {
    this.trust_urls.splice(index, 1);
  }

  getRangesTooltipContent(type) {
    const tooltipData = {
      range: 'Defines the upper and lower monetary limits (of the customer’s basket size) for the selected promotional plan and term.',
      plan: 'Choose from the financing plans you have available with Flexiti.',
      term: 'Where applicable, this will be the length of the promotional term (in months) available to customers for a specific financing plan.'
    }

    return tooltipData[type];

  }

  shouldHavePlanAndTermsQuebec() {
    return this.userData.enable_quebec_exception_plans;
  }

  shouldHavePlanAndTermsNonPrime() {
    return this.offerNonPrime && this.offerPlansNonPrime.length > 0;
  }


  userIsPOSRole() {
    return this.userData.role === 'POS';
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-users-detail/admin-users-detail.ts